import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";
import type {
  GetCosignQueueResponse,
  GetCosignQueueSearchParams,
} from "@/core/types/(api)/cosignature";

export async function getCosignatureQueue(
  searchParams?: GetCosignQueueSearchParams,
  signal?: AbortSignal,
): Promise<GetCosignQueueResponse> {
  return cosignatureRequestsTyped.get_cosign_queue({ searchParams, signal });
}
